import { useState, useCallback } from 'react';
import {
  presignCertificacionAttachmentUpload,
  confirmCertificacionAttachment,
} from 'api/certificacionAttachment';

/**
 * Hook para subir un adjunto (PDF del certificado MINVU, acta, foto, anexo)
 * a una certificación via presigned PUT a S3.
 *
 * Flow:
 *   1) POST /certificaciones/:id/attachments/presign-upload -> { uploadUrl, key }
 *   2) PUT directo al uploadUrl con Content-Type del archivo
 *   3) POST /certificaciones/:id/attachments/confirm -> persiste fila
 *   4) resolve(attachment)
 */
export function useCertificacionAttachmentUpload() {
  const [loading, setLoading] = useState(false);

  const upload = useCallback(async (certId, file) => {
    if (!certId) throw new Error('useCertificacionAttachmentUpload: certId requerido');
    if (!file) throw new Error('useCertificacionAttachmentUpload: file requerido');
    setLoading(true);
    try {
      const contentType = file.type;
      const filename = file.name;
      const { uploadUrl, key } = await presignCertificacionAttachmentUpload(
        certId,
        contentType,
        filename
      );
      const putRes = await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': contentType },
        body: file,
      });
      if (!putRes.ok) {
        throw new Error(`S3 PUT failed: ${putRes.status} ${putRes.statusText}`);
      }
      const attachment = await confirmCertificacionAttachment(certId, {
        key,
        filename,
        contentType,
        sizeBytes: file.size,
      });
      return attachment;
    } finally {
      setLoading(false);
    }
  }, []);

  return { upload, loading };
}
